import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import { useSettings } from '../context/SettingsContext';

const MODULE_LABELS = {
    calendar: 'Kalender', invitations: 'Einladungen', addressbook: 'Adressbuch',
    administration: 'Verwaltung', teams: 'Teams', services: 'Dienstplaner',
    carpooling: 'Fahrgemeinschaften', resources: 'Ressourcen', ticker: 'Live-Ticker',
    tournaments: 'Turniere', children: 'Meine Kinder',
    news: 'News', chat: 'Nachrichten', tasks: 'Maßnahmen',
    documents: 'Dokumentenablage', facility: 'Inventar & Mängel', meetings: 'Sitzungen',
};

// Full-page lock shown when a user opens a module their plan does not include.
const ModuleLocked = ({ module }) => {
    const navigate = useNavigate();
    const { entitlements } = useSettings();
    const label = MODULE_LABELS[module] || 'Dieses Modul';
    const planName = entitlements?.plan?.name || entitlements?.club?.plan_name;

    return (
        <div className="min-h-[70vh] flex items-center justify-center p-6" data-testid="module-locked">
            <div className="max-w-md text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-amber-100 mb-5">
                    <Lock size={30} className="text-amber-600" />
                </div>
                <h2 className="text-2xl font-bold text-slate-900 mb-2">{label} ist nicht freigeschaltet</h2>
                <p className="text-slate-600 mb-1">
                    Dieses Modul ist in Ihrem aktuellen Abo{planName ? ` „${planName}"` : ''} nicht enthalten.
                </p>
                <p className="text-slate-500 text-sm mb-6">
                    Upgraden Sie Ihr Abo, um {label} für Ihren Verein zu nutzen.
                </p>
                <div className="flex gap-3 justify-center">
                    <Button onClick={() => navigate('/')} variant="outline" data-testid="module-locked-back">
                        Zurück zum Dashboard
                    </Button>
                    <Button onClick={() => navigate('/users?tab=abo')} className="bg-blue-600 hover:bg-blue-700 text-white" data-testid="module-locked-upgrade">
                        <Sparkles size={16} className="mr-2" /> Abo ansehen
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ModuleLocked;
